<template>
<div>
  <v-layout row wrap justify-center>
    <v-flex class="px-2 pb-3" xs12 sm10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else class="py-3 px-2" row wrap justify-center>
        <v-flex v-if="tasks.length == 0" class="py-5" xs12>
          <div class="text-xs-center display-3 grey--text text--lighten-1">
            None
          </div>
        </v-flex>
        <v-flex v-else class="px-2 pb-3" xs12 md10>
          <v-expansion-panel class="elevation-0">
            <v-expansion-panel-content class="mb-3" v-for="t, i in tasks" :key="i">
              <div slot="header">
                <div class="title primary--text">
                  <span><b>{{t.name}}</b></span>
                </div>
              </div>
              <v-card>
                <v-layout row wrap>
                  <v-flex class="pb-1" xs12>
                    <v-btn
                      :to="'/content/' + contentData.url + '/' + sectionData.url + '/' + t.url"
                      class="my-0 ml-3"
                      color="primary"
                      flat
                      small
                    ><b>View Task</b></v-btn>
                  </v-flex>
                  <v-flex v-if="t.type == 'Reading'" class="subheading pb-2 pl-4" xs12>
                    <div v-if="t.text">
                      <div v-if="t.text.length > 10">
                        <div v-if="t.text.length > 300">
                          <div class="quill-preview" v-html="t.text.slice(0,300) + '...<br><b>View Task to read more</b>'"></div>
                        </div>
                        <div v-else class="quill-preview" v-html="t.text"></div>
                      </div>
                      <div v-else>No Text Written</div>
                    </div>
                    <div v-else>No Text Written</div>
                  </v-flex>
                  <v-flex v-else-if="t.type == 'Lecture'" class="subheading pb-2 pl-4" xs12>
                    <div v-if="t.fileName">
                      <div v-if="t.fileName.length > 0">
                        <div><b>Video:</b> {{t.fileDetails}}</div>
                      </div>
                      <div v-else>No Video Uploaded</div>
                    </div>
                    <div v-else>No Video Uploaded</div>
                  </v-flex>
                  <v-flex v-else-if="t.type == 'Practice' || t.type == 'NCLEX'" class="subheading pb-2 pl-4" xs12>
                    <div>Type: <b>{{t.type == 'NCLEX' ? (t.tags + ' ') : ''}}{{t.type + ' Test'}}</b></div>
                    <div v-if="t.type == 'Practice'">
                      <b>{{t.numOfQuestions}} total questions</b> with 
                      <b>{{t.percentEasy ? Math.round(t.numOfQuestions * (t.percentEasy / 100)) : 'random'}} easy questions</b>
                    </div>
                    <div v-else>
                      <b>{{t.minQuestions}}</b> to <b>{{t.maxQuestions}}</b> questions per NCLEX area
                    </div>
                    <div>
                      <b>{{t.timeAllowed ? t.timeAllowed + ' mins' : 'Unlimited'}}</b> time limit with <b>{{t.attempts ? t.attempts : 'unlimited'}}</b> attempts
                    </div>
                  </v-flex>
                  <v-flex v-else-if="t.type == 'Practice' || t.type == 'NCLEX'" class="subheading pb-2 pl-4" xs12>
                    <div>
                      Type: <b>{{t.type == 'NCLEX' ? (t.tags + ' ') : ''}}{{t.type + ' Test'}}</b>
                    </div>
                    <div v-if="t.type == 'Practice'">
                      <v-chip class="subheading" color="grey lighten-1" v-for="t in t.tags" :key="t" selected small>
                        {{t}}
                      </v-chip>
                    </div>
                    <div v-if="t.type == 'Practice'">
                      <b>{{t.numOfQuestions}} total questions</b> with 
                      <b>{{t.percentEasy ? Math.round(t.numOfQuestions * (t.percentEasy / 100)) : 'random'}} easy questions</b>
                    </div>
                    <div v-else>
                      <b>{{t.minQuestions}}</b> to <b>{{t.maxQuestions}}</b> questions per NCLEX area
                    </div>
                    <div>
                      <b>{{t.timeAllowed ? t.timeAllowed : 'Unlimited'}} mins</b> time limit with <b>{{t.attempts ? t.attempts : 'unlimited'}}</b> attempts
                    </div>
                  </v-flex>
                  <v-flex v-else-if="t.type == 'Linking'" class="subheading pb-2 pl-4" xs12>
                    <div>
                      <span>Linked with: <b>{{linkedTaskPath(t)}}</b></span>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    tasks: [],
    contentData: {},
    sectionData: {}
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      const sections = this.$store.getters.sectionByContent(this.contentData.key)
      for (let s of sections) {
        if (s.url === this.$route.params.sectionUrl) this.sectionData = s
      }
      this.tasks = this.$store.getters.taskBySection(this.sectionData.key)
      this.tasks.sort((a, b) => {
        return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'})
      })
      this.loading = false
    },
    linkedTaskPath (task) {
      let path = ''
      if (task.linkedTaskKey) {
        let linkedTask = this.$store.getters.taskByKey(task.linkedTaskKey)
        let section = this.$store.getters.sectionByKey(linkedTask.sectionKey)
        let content = this.$store.getters.contentByKey(section.contentKey)
        path = content.name + ' / ' + section.name + ' / ' + linkedTask.name
      }
      return path
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/TaskList.vue